module.exports = __webpack_public_path__ + "static/media/fashion-counsil.1cb4455c.png";